import { render } from "./HeaderStats.vue?vue&type=template&id=17bf9669&scoped=true"
import script from "./HeaderStats.vue?vue&type=script&lang=js"
export * from "./HeaderStats.vue?vue&type=script&lang=js"

import "./HeaderStats.vue?vue&type=style&index=0&id=17bf9669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf9669"],['__file',"src/components/Headers/HeaderStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17bf9669"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17bf9669', __exports__)) {
    api.reload('17bf9669', __exports__)
  }
  
  module.hot.accept("./HeaderStats.vue?vue&type=template&id=17bf9669&scoped=true", () => {
    api.rerender('17bf9669', render)
  })

}


export default __exports__